export default {
    state: {
        userId:"B6BEAAD6-E14B-C0BC-1DCA-2FA5FEF5D602",
        passWord:"gxfybjyzzj",
        userName:"自助机",
        token:"",
        tokenYxsj:"",
    },
    actions: {
        changeToken:(context,para)=>{
            context.commit('changeToken',para)
        },
        changeTokenYxsj:(context,para)=>{
            context.commit('changeTokenYxsj',para)
        },
    },
    mutations: {
        changeToken:(state,para)=>{
            state.token =   para
        },
        changeTokenYxsj:(state,para)=>{
            state.tokenYxsj =   para
        }
    }
}